import Link from "next/link";
import { BikeCard } from "../bikeGridList/bikeCard";
import { createAvailabilityLookupTable, massageBikeAndSubData } from "../bikeGridList/lib";
import { BikeATStore, IBikeStore } from "/lib/bike";
import {
  ISubscriptionStore,
  SubscriptionATStore,
  getUniqueSubscriptionsForBikes
} from "/lib/subscription";
import { FrontPageChosenBike } from "/lib/sanity/queries/frontPage";
import { createLookupTable } from "/lib";

async function getData({
  bikeTypeIds,
  chosenBikesSanityData
}: {
  bikeTypeIds: string[];
  chosenBikesSanityData: FrontPageChosenBike;
}) {
  const bikeStore: IBikeStore = new BikeATStore();
  const subscriptionsStore: ISubscriptionStore = new SubscriptionATStore();

  const bikeModels = await bikeStore.getBikeModels(bikeTypeIds);

  const subscriptions = await getUniqueSubscriptionsForBikes(subscriptionsStore, bikeModels);

  const availabilityTable = createAvailabilityLookupTable(bikeModels);

  const bikeModelsTable = createLookupTable(chosenBikesSanityData, "id");

  const massagedData = massageBikeAndSubData(
    bikeModels,
    subscriptions,
    bikeModelsTable,
    availabilityTable
  );

  return massagedData;
}

export default async function ChosenBikeList({
  bikeTypeIds,
  chosenBikesSanityData
}: {
  bikeTypeIds: string[];
  chosenBikesSanityData: FrontPageChosenBike;
}) {
  const bikes = await getData({ bikeTypeIds: bikeTypeIds, chosenBikesSanityData });

  return (
    <article className="flex flex-col gap-8">
      <h3 className="">Anbefalte sykler</h3>
      <div className="items-center gap-6 flex lg:grid lg:grid-cols-3 grid-rows-auto grid-flow-row h-1/2 w-full min-w-full overflow-x-auto scrollbar-hide">
        {bikes.map((bike, index) => {
          return <BikeCard key={index} bike={bike} className="min-w-[300px]" />;
        })}
      </div>
      <Link href={"/sykler"} className="underline self-center text-[16px]">
        Se alle sykkelmodellene våre
      </Link>
    </article>
  );
}
